import { useEffect, useMemo } from "react";

import styled from "styled-components/macro";

import { motion } from "framer-motion";

import { ActionButton } from "../ActionButton";
import { useOnCTAClick } from "../stateHooks";

export default function GiveToFund({
  fundInfo,
  fundName,
  title,
  description,
  image,
  isHovering,
  action,
  setAction,
}) {
  const onCTAClick = useOnCTAClick();
  const displayFundName = fundName || fundInfo?.fundName;
  const actionText = useMemo(() => {
    switch (fundInfo?.fundVerbiage) {
      case "Donation":
        return "Donate Now";
      case "Payment":
        return "Make a Payment";
      default:
        return "Give Now";
    }
  }, [fundInfo?.fundVerbiage]);

  useEffect(() => {
    setAction(actionText);
  }, [action, actionText, setAction]);

  return (
    <SDiv onClick={onCTAClick} data-cy="GiveToFund_Link">
      <Wrapper>
        <TextContent>
          <Title>{title || `Give to ${displayFundName}`}</Title>
          {description && <Description>{description}</Description>}
        </TextContent>
        {image && <ImageContent style={{ backgroundImage: `url(${image})` }} />}
      </Wrapper>
      {action && <ActionButton action={action} isHovering={isHovering} />}
    </SDiv>
  );
}

const Wrapper = styled.div`
  padding: 16px;
  box-sizing: border-box;
  z-index: 10;
  margin: 8px 8px 40px 8px;
  word-break: break-word;
`;
const Title = styled.div`
  font-weight: 600;
  font-size: 20px;
`;
const Description = styled.div`
  font-weight: 400;
`;
const TextContent = styled(motion.div)`
  flex-grow: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const ImageContent = styled.div`
  aspect-ratio: 1;
  background: #fff;
  flex-shrink: 0;
  border-radius: 12px;
  margin-top: -4px;
  margin-right: -4px;
  height: calc(100% + 8px);
  background-size: cover;
  background-position: center center;
`;
const SDiv = styled.div`
  text-decoration: none !important;
  color: inherit;
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
